"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import $ from "jquery";
import Account from "../api/account";
import "../formatters/general";
import TypeAhead from "./ui/type_ahead";
import Auth from "../util/auth";
function formatAddress(address) {
  var html = "<br>";
  if (address.address_line_1) {
    html += address.address_line_1 + " ";
  }
  html += address.city + " ";
  html += address.state + " ";
  html += address.postal_code + " ";
  return html;
}
function carrierDisplay(carrier) {
  var html = carrier.name;
  if (carrier.mc_number) {
    html += " - MC# ";
    html += carrier.mc_number;
  }
  if (carrier.ein) {
    html += " - EIN ";
    html += carrier.ein;
  }
  if (carrier.scac) {
    html += " - SCAC ";
    html += carrier.scac;
  }
  if (carrier.external_vendor_id) {
    var acct = Auth._currentUser.account;
    if (acct.factor_account || acct.settings.show_carrier_external_vendor_id) {
      html += " - ";
      html += carrier.external_vendor_id;
    }
  }
  if (carrier.address_line_1 || carrier.city) {
    html += formatAddress(carrier);
  } else if (carrier.payment_address) {
    if (carrier.payment_address.address_line_1 || carrier.payment_address.city) {
      html += formatAddress(carrier.payment_address);
    }
  }
  return html;
}
class CarrierTypeAhead extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "search", (name) => {
      var component = this;
      return Promise.resolve(
        // TODO: use fetch instead
        // eslint-disable-next-line no-restricted-syntax
        $.get("/api/carriers", { page: 1, term: name })
      ).then(function(data) {
        const results = data.carriers;
        if (name[0].toLowerCase() === "u" && component.props.includeUnknown) {
          results.unshift({ name: "Unknown " + Account.carrierTerm(), id: "" });
        }
        return results;
      });
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      TypeAhead,
      {
        "data-component": "CarrierTypeAhead",
        remoteSearch: this.search,
        display: carrierDisplay,
        readOnly: this.props.readOnly,
        autoFocus: this.props.autoFocus,
        placeHolder: Account.carrierTerm() + " Name",
        className: "carrier-setter__typeahead",
        isDroppable: true,
        selectedItem: this.props.carrier,
        onSelectItem: this.props.onSelectCarrier,
        onClearSelectedItem: this.props.onClearCarrier,
        onSubmit: this.props.onSubmit,
        showTextArea: this.props.showTextArea
      }
    );
  }
}
export default CarrierTypeAhead;
